import React from 'react';
import { Routes, Route, BrowserRouter, useInRouterContext } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

// Components
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

// Pages
import Home from './pages/Home';
import Services from './pages/Services';
import Safety from './pages/Safety';
import About from './pages/About';
import References from './pages/References';
import Courses from './pages/Courses';
import Contact from './pages/Contact';
import ScrapedPage from './pages/ScrapedPage';

function OptionalBrowserRouter({ children }) {
  try {
    const inRouter = useInRouterContext();
    if (inRouter) {
      return <>{children}</>;
    }
  } catch (e) {
    // Fallback if context is not fully initialized
  }
  return <BrowserRouter>{children}</BrowserRouter>;
}

function AppContent() {
  return (
    <div className="relative min-h-screen flex flex-col bg-[#f7f8fa] text-[#0e1f2f] antialiased selection:bg-[#3c8888]/10 selection:text-[#3c8888]">
      {/* Subtle background grid & glow patterns inspired by industrial engineering */}
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(14,31,47,0.04),transparent_60%)]" />
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage:
            'linear-gradient(rgba(14,31,47,0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(14,31,47,0.1) 1px, transparent 1px)',
          backgroundSize: '64px 64px',
        }}
      />

      {/* Scroll Restoration */}
      <ScrollToTop />

      {/* Navigation Header */}
      <Header />

      {/* Main Content Area */}
      <main className="flex-grow relative z-10">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/ydelser" element={<Services />} />
          <Route path="/om-carpa" element={<About />} />
          <Route path="/referencer" element={<References />} />
          <Route path="/kurser" element={<Courses />} />
          <Route path="/kontakt" element={<Contact />} />
          <Route path="/risk-functional-safety" element={<Safety />} />
          
          {/* Dynamic route for all scraped pages */}
          <Route path="/:slug" element={<ScrapedPage />} />
        </Routes>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <OptionalBrowserRouter>
        <AppContent />
      </OptionalBrowserRouter>
    </HelmetProvider>
  );
}

export default App;
